module.exports = __webpack_public_path__ + "media/images/close-btn-589bdf90d01154110abe60076d454105.svg";